import { Component, inject } from '@angular/core';
import { TranslatePipe } from '@ngx-translate/core';

import { PathFilterBarState } from '../path-filter-bar.state';

/**
 * The panel footer's two moves between the search bar and the composer, for a host that saves the
 * composer side: what is typed in the bar can only reach a preset by moving into the composer.
 */
@Component({
  selector: 'app-path-filter-move-buttons',
  imports: [TranslatePipe],
  templateUrl: './path-filter-move-buttons.component.html',
  styles: `
    :host {
      display: contents;
    }
  `
})
export class PathFilterMoveButtonsComponent {
  protected readonly pathBar = inject(PathFilterBarState);
}
